import React from 'react'

const ProductSearchList = () => {
  return (
    <div style={{ width: '100%', height: '99vh', margin: 0, padding: 0 }}>
      <iframe
        style={{ width: '100%', height: '100%', margin: 0, padding: 0 }}
        src="https://metabase.seacorp.vn/public/question/a7f08a77-c1c2-4d37-990f-4c10d6392918?company=&name=&code="
        title="Product Search List"
      />
    </div>
  )
}

export default ProductSearchList
